module.exports = __webpack_public_path__ + "img/banner-manage.19414526.png";